import { render } from "./App.vue?vue&type=template&id=db9ca446"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=db9ca446&lang=css"

import exportComponent from "C:\\Users\\kegel\\Documents\\WAV\\Diagnosis Tool Updates\\repo\\diagnosis-tool\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__